var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAdm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 76H12.5C8.9 76 6 73 6 69.3V63.5V51.8V6.7C6 3 8.9 0 12.5 0H45.6C49.1 0 52 3 52 6.7V69.4C52 73 49.1 76 45.5 76ZM8.8 66.4V69.3C8.8 71.4 10.5 73 12.4 73H45.5C47.5 73 49.1 71.3 49.1 69.3V6.7C49.1 4.6 47.5 3 45.5 3H12.5C10.5 3 8.9 4.7 8.9 6.7V48.9V66.4H8.8Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69.2H26V70.9H32V69.2Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7C30 7.6 29.6 8 29 8C28.4 8 28 7.6 28 7C28 6.4 28.4 6 29 6C29.6 6 30 6.4 30 7Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 66H46V10H12V66Z",
    fill: "#FF8300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49.1V63.6L43.3 74H58.9L69 63.8V48.4L58.7 38H43.8L33 49.1Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72.5H58.3L67.5 63.2V49L58.1 39.5H44.5L34.5 49.7V63L44 72.5ZM59.3 75H42.9L32 64V48.6L43.4 37H59.1L70 48V64.3L59.3 75Z",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50.6V61.9L45 70H57.2L65 62.1V50.1L57 42H45.4L37 50.6Z",
    fill: "#FF8300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9 50L51.1 54.2L55.2 50.2L57.1 52.1L53 56.1L56.9 60L55 61.9L51 57.9L46.8 61.9L45 60.1L49.2 56L45 51.9L46.9 50Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAdm);
export default __webpack_public_path__ + "static/media/warningAdm.218333c5fd209b29ed2f4caa39393156.svg";
export { ForwardRef as ReactComponent };